import { getContext, call, put } from 'redux-saga/effects';
import { fromBBAN } from 'iban';
import { getLogger } from '../../logger/index';
import { sendViewerSettings } from '../communication/actions';

const logger = getLogger('communicationVideo :: kvsSettings');

export function* fetchAndPropagateKVSSettingsSaga(to, type, from, customerCallId) {
  let kvsSettings;
  try {
    logger.debug('Fetch Kinesis Video Stream settings');
    kvsSettings = yield call(fetchKVSSettings, {
      target: to.id,
      type,
      customerCallId,
      email: from.id,
      name: from.name,
    });

    // we have the video settings for amazon kinesis video stream
    // we need to share the settings with the viewer
    logger.debug('Send settings to the viewer', kvsSettings);
    yield put(
      sendViewerSettings({
        to: to.id,
        clientId: kvsSettings.to,
        region: kvsSettings.region,
        customerVideoCall: kvsSettings.customerVideoCallId,
        accessKeyId: kvsSettings.accessKeyId,
        secretAccessKey: kvsSettings.secretAccessKey,
        sessionToken: kvsSettings.sessionToken,
        channelARN: kvsSettings.channelARN,
        channelEndpoints: kvsSettings.viewerChannelEndpoints,
        iceServers: kvsSettings.viewerIceServers,
      })
    );
  } catch (e) {
    logger.error(e);
  }

  return kvsSettings;
}

function* fetchKVSSettings({ target, type, customerCallId, email, name }) {
  const http = yield getContext('http');
  const requestUrl = customerCallId
    ? `/api/video/masterinfos.json?customerVideoCallId=${customerCallId}&type=${type}&email=${email}&name=${name}`
    : `/api/video/masterinfos.json?target=${target}&type=${type}`;
  const response = yield call(http.get, requestUrl);
  logger.debug('fetch KVSSettings response', response);

  return response.data;
}

export function* fetchAndPropagateCustomerKVSSettingsSaga({
  username,
  name,
  type,
  isAnonymousUser,
  customerVideoCall,
}) {
  let kvsSettings;
  try {
    logger.debug('Fetch Kinesis Video Stream settings', {
      username,
      name,
      type,
      isAnonymousUser,
      customerVideoCall,
    });
    kvsSettings = yield call(fetchKVSSettingsForCustomer, {
      username,
      name,
      type,
      isAnonymousUser,
      customerVideoCall,
    });

    // we have the video settings for amazon kinesis video stream
    // we need to share the settings with the viewer
    logger.debug('Send settings to the viewer');
    yield put(
      sendViewerSettings({
        to: username,
        customerVideoCall,
        clientId: kvsSettings.to,
        region: kvsSettings.region,
        accessKeyId: kvsSettings.accessKeyId,
        secretAccessKey: kvsSettings.secretAccessKey,
        sessionToken: kvsSettings.sessionToken,
        channelARN: kvsSettings.channelARN,
        channelEndpoints: kvsSettings.viewerChannelEndpoints,
        iceServers: kvsSettings.viewerIceServers,
      })
    );
  } catch (e) {
    logger.error(e);
  }

  return kvsSettings;
}

function* fetchKVSSettingsForCustomer({ username, name, type, isAnonymousUser, customerVideoCall }) {
  const http = yield getContext('http');

  const response = yield call(http.get, `/api/video/masterinfos.json`, {
    params: {
      customerVideoCallId: customerVideoCall,
      type,
      ...(isAnonymousUser ? { email: username, name } : { target: username }),
    },
  });
  logger.debug('fetch KVSSettings response', response);

  return response.data;
}
